<template>
  <div>
    <div class="head">
      <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        :header-cell-style="{ background: 'rgb(250,250,250)' }"
        style="width: 100%">
        <el-table-column prop="number" label="统一编码" />
        <el-table-column prop="name" label="品名" />
        <el-table-column prop="warningType" label="是否为危险化学品">
          <template slot-scope="{ row }">
            {{ row.dangerousChemicalType === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="form" label="物质形态">
          <template slot-scope="{ row }">
            {{ formList[row.form] }}
          </template>
        </el-table-column>
        <el-table-column prop="consumptionForYear" label="年消耗量" />
        <el-table-column prop="maxStorageVolume" label="最大储存量" />
        <el-table-column prop="practicalStorageVolume" label="实际储量" />
        <el-table-column prop="storageLocation" label="存储位置" />
        <el-table-column prop="storageMethod" label="存储方式" />
        <el-table-column prop="toxicChemicals" label="是否剧毒化学品">
          <template slot-scope="{ row }">
            {{ row.toxicChemicals === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="superviseToxicChemicals" label="是否重点监管危险化学品">
          <template slot-scope="{ row }">
            {{ row.superviseToxicChemicals === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="emphasisToxicChemicals" label="是否特别管控危险化学品">
          <template slot-scope="{ row }">
            {{ row.emphasisToxicChemicals === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { rawMaterialList, rawMaterialDelete } from '@/api/processManager';
export default {
  name: 'ProcessEndProducts',
  data() {
    return {
      tableData: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      // 物质形态的数组
      formList: ['','固态','液态','气态','等离子态']
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    getTableData() {
      rawMaterialList({ limit: this.pageSize, curPage: this.curPage, type: 2, isPage: 1 }).then(res => {
        this.total = res.body.cum
        this.tableData = res.body.data
      })
    },
    pageChange(val) {
      this.curPage = val;
      this.getTableData();
    },
    addBtn() {
      this.$router.push(
        { path: 'AddRawMaterials', query: { status: 2 } }
      )
    },
    // 编辑
    editBtn(row) {
      this.$router.push({
        name: 'AddRawMaterials',
        params: { key: row },
        query: { status: 2 }
      })
    },
    deleteBtn(row) {
      rawMaterialDelete(row.id).then(res => {
        this.$message.success('删除成功')
        this.getTableData()
      })
    }
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}
.btn {
  cursor: pointer;
}
</style>